import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import { setLink, useLink } from "../../utils/ClickedLink";
import { useState } from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [currentLink, setCurrentLink] = useState(useLink());

    const navigate = useNavigate();
  const handleLinkClick = (link, path) => {
      setLink(link);
      setCurrentLink(link);
      if (path) navigate(path);
      // setMobileMenuOpen(false); // close menu on mobile
      // setCountryDropdownOpen(false); // close dropdown
    };

    const handleSendEmail = () => {
      const to = "info@mambahikers.com";
      const subject = encodeURIComponent("Hello from My App");
      const body = encodeURIComponent(
        "Hi there,\n\nI wanted to reach out to you..."
      );

      const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}`;

      window.open(gmailUrl, "_blank");
    };

  return (
    <footer className="bg-gradient-to-br from-mamba-navy via-slate-900 to-mamba-navy pt-16 pb-24 relative">
      <div className="flex flex-col md:flex-row justify-around p-12">
        {/* About Us */}
        <div className="md:w-2/5 mb-8 md:mb-0">
          <a
            href="/"
            target="_top"
            className="inline-block cursor-pointer mb-4"
          >
            <img src={logo} alt="logo" className="h-12" />
          </a>
          <h3 className="text-3xl md:text-4xl font-bold font-montserrat text-white mb-4">
            Mamba <span className="italic font-dancing-script text-mamba-golden">Hikers</span> Expeditions
          </h3>
          <p className="text-white/80 font-inter leading-relaxed">
            At Mamba Hikers, we're not just about conquering peaks, we're about
            conquering yourself. Every summit we reach is a step towards
            rediscovering the wild spirit within. We're a tribe of adventure
            seekers, united by the rhythm of boots on dirt and the thrill of
            pushing beyond our limits.
          </p>
        </div>

        {/* Contacts */}
        <div className="md:w-1/4 mb-8 md:mb-0">
          <h3 className="text-3xl md:text-4xl font-bold font-montserrat text-white mb-6">Get In <span className="italic font-dancing-script text-mamba-golden">Touch</span></h3>
          <ul className="space-y-4 text-white/80 font-inter">
            <li className="flex items-center group">
              <i className="fas fa-phone text-mamba-golden pr-4 group-hover:scale-110 transition-transform"></i>
              <a href="tel:+254714818723" className="hover:text-mamba-golden transition-colors">
                +254 714 818 723
              </a>
            </li>
            <li className="flex items-center group">
              <i className="fas fa-envelope text-mamba-golden pr-4 group-hover:scale-110 transition-transform"></i>
              <a
                href="mailto:info@mambahikers.com"
                className="hover:text-mamba-golden transition-colors"
              >
                info@mambahikers.com
              </a>
            </li>
            <li className="flex items-center group">
              <i className="fas fa-map-marker-alt text-mamba-golden pr-4 group-hover:scale-110 transition-transform"></i>
              <span className="hover:text-mamba-golden transition-colors">J's Arcade, Thome Outlet Number J28</span>
            </li>
          </ul>

          {/* Social Media */}
          <div className="flex gap-4 mt-8">
            <a
              href="https://www.facebook.com/mambahikers"
              target="_blank"
              rel="noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center hover:bg-mamba-golden hover:scale-110 transition-all"
            >
              <i className="fab fa-facebook-f text-xl text-white"></i>
            </a>
            <a
              href="https://x.com/Mambahikers?t=zN1p261-8xzi5ERoSEFNoA&s=09"
              target="_blank"
              rel="noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center hover:bg-mamba-golden hover:scale-110 transition-all"
            >
              <i className="fab fa-twitter text-xl text-white"></i>
            </a>
            <a
              href="https://www.instagram.com/mambahikers?igsh=MWNwZXQweDd6ODdoZg=="
              target="_blank"
              rel="noreferrer"
              className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center hover:bg-mamba-golden hover:scale-110 transition-all"
            >
              <i className="fab fa-instagram text-xl text-white"></i>
            </a>
          </div>
        </div>

        {/* Useful Links */}
        <div className="md:w-1/4">
          <h3 className="text-3xl md:text-4xl font-bold font-montserrat text-white mb-6">Useful <span className="italic font-dancing-script text-mamba-golden">Links</span></h3>
          <ul className="space-y-3 text-white/80 font-inter">
            <li
              className="hover:translate-x-2 transition-transform cursor-pointer hover:text-mamba-golden"
              onClick={() => handleLinkClick("home", "/")}
            >
              Home
            </li>
            <li
              className="hover:translate-x-2 transition-transform cursor-pointer hover:text-mamba-golden"
              onClick={() =>
                handleLinkClick("destinations", `/country/destinations/ke`)
              }
            >
              Destinations
            </li>
            <li
              className="hover:translate-x-2 transition-transform cursor-pointer hover:text-mamba-golden"
            >
              <a
                href="https://drive.google.com/file/d/1w1sjQbVp8HuSZW7vMiKsxRugIg5gYTpA/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                Our Policies
              </a>
            </li>
            <li className="hover:translate-x-2 transition-transform cursor-pointer hover:text-mamba-golden">
              <a
                href="https://www.instagram.com/mambahikers_gear_shop?igsh=MThtc28xdGNuaWNqcw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                Shop With Us
              </a>
            </li>
            <li
              className="hover:translate-x-2 transition-transform cursor-pointer hover:text-mamba-golden"
              onClick={handleSendEmail}
            >
              Contact Us
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="absolute bottom-0 bg-black/30 backdrop-blur-sm w-full py-4 text-white/90 text-center border-t border-white/10">
        <p className="font-inter text-sm">
          &copy; {currentYear} <span className="font-semibold text-mamba-golden">Mamba Hikers</span> Tours and Travel. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
